import { Driver, DriverHook } from "driver.js";
import { defaultTourConfig } from ".";
import { filterMarketplaceSteps } from "./marketplaceSteps";

// Export the tour steps so they can be reused in GrandTour
export const brandsAndProgramsTourSteps = [
  {
    element: "#brands",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
          <div class="flex -space-x-2">
            <div class="w-6 h-6 bg-brand-200 rounded-full border-2 border-white flex items-center justify-center">
              <svg class="w-3 h-3 text-brand-600" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>
              </svg>
            </div>
            <div class="w-6 h-6 bg-brand-300 rounded-full border-2 border-white flex items-center justify-center">
              <svg class="w-3 h-3 text-brand-700" fill="currentColor" viewBox="0 0 24 24">
                <path d="M3 17l6-6 4 4 8-8v3h2V4h-6v2h3l-7 7-4-4-6 6v2z"></path>
              </svg>
            </div>
            </div>
        </div>
        <div class="flex items-center gap-2">
          <span class="text-base font-semibold text-foreground">Welcome to Brands and Programs for affiliates!</span>
        </div>
      </div>`,
      description: `<div class="space-y-3">
    <p class="text-[12px] text-muted-foreground leading-relaxed"> This tour provides information about brands you can work with.</p>
    <div class="bg-brand-50 p-3 rounded-lg border-l-4 border-brand-400">
      <div class="flex items-start gap-2">
        <svg class="w-4 h-4 text-brand-600 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>
<div class="text-[12px] text-brand-700">Our platform uses a ranking system to determine the best brands to work with. You can also filter brands by category, country, and more.</div>
      </div>
    </div>
    <div class="flex items-center gap-2 text-xs text-brand-600">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
      </svg>
      <span>Estimated time: 1 minute</span>
    </div>
  </div>`,
      side: "right" as const,
      align: "start" as const,
    },
  },
  {
    element: "#active-brands",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
        
          <div class="flex -space-x-2">
            <div class="w-6 h-6 bg-brand-200 rounded-full border-2 border-white flex items-center justify-center">
              <svg class="w-3 h-3 text-brand-600" fill="currentColor" viewBox="0 0 24 24">
                <path d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
              </svg>
            </div>
            <div class="w-6 h-6 bg-brand-300 rounded-full border-2 border-white flex items-center justify-center">
              <svg class="w-3 h-3 text-brand-700" fill="currentColor" viewBox="0 0 24 24">
                <path d="M3 17l6-6 4 4 8-8v3h2V4h-6v2h3l-7 7-4-4-6 6v2z"></path>
              </svg>
            </div>
            </div>
        </div>
        <div class="flex items-center gap-2">
          <span class="text-base font-semibold text-foreground">Active Brands</span>
        </div>
      </div>`,
      description: `<div class="space-y-3">
        <p class="text-[12px] text-muted-foreground leading-relaxed">This section contains list of brands that you are currently working with.</p>
        <div class="bg-brand-50 p-3 rounded-lg">
          <div class="flex items-center gap-2 mb-2">
            <p class="text-xs font-medium text-brand-800">Active Brands Features:</p>
          </div>
          <ul class="text-xs text-brand-700 space-y-3">
            <li class="flex items-start gap-3">
              <div class="w-6 h-6 bg-brand-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                <svg class="w-3 h-3 text-brand-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"></path>
                </svg>
              </div>
              <div class="flex-1">
                <div class="text-brand-700">Click on a brand to view its detailed profile.</div>
              </div>
            </li>
          </ul>
        </div>
        <div class="flex items-center gap-2 text-xs text-brand-600">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          <span>You can join multiple brands to increase your earnings.</span>
        </div>
      </div>`,
      side: "right" as const,
      align: "start" as const,
    },
  },
  {
    element: "#search-brands",
    marketplaceOnly: true,
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
        
          <div class="flex -space-x-2">
            <div class="w-6 h-6 bg-brand-200 rounded-full border-2 border-white flex items-center justify-center">
              <svg class="w-3 h-3 text-brand-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
              </svg>
            </div>
            <div class="w-6 h-6 bg-brand-300 rounded-full border-2 border-white flex items-center justify-center">
              <svg class="w-3 h-3 text-brand-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
              </svg>
            </div>
            </div>
        </div>
        <div class="flex items-center gap-2">
          <span class="text-base font-semibold text-foreground">Search Brands</span>
        </div>
      </div>`,
      description: `<div class="space-y-3">
        <p class="text-[12px] text-muted-foreground leading-relaxed">This is a place where you can find potential brands to work with and expand your empire.</p>
        <div class="bg-brand-50 p-3 rounded-lg">
          <ul class="text-xs text-brand-700 space-y-3">
            <li class="flex items-start gap-3">
              <div class="w-6 h-6 bg-brand-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                <svg class="w-3 h-3 text-brand-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"></path>
                </svg>
              </div>
              <div class="flex-1">
                <div class="font-medium text-brand-800 mb-1">Search Brands</div>
                <div class="text-brand-700">Use the search bar to quickly find specific brands by name and much more.</div>
              </div>
            </li>
            <div class="flex items-center justify-center gap-2 px-8">
              <div class="h-px w-12 bg-gradient-to-r from-transparent via-brand-300 to-transparent"></div>
              <div class="h-1.5 w-1.5 rounded-full bg-brand-300"></div>
              <div class="h-px w-12 bg-gradient-to-r from-transparent via-brand-300 to-transparent"></div>
            </div>
            <div class="flex items-center justify-center gap-2 px-8">
              <div class="h-px w-12 bg-gradient-to-r from-transparent via-brand-300 to-transparent"></div>
              <div class="h-1.5 w-1.5 rounded-full bg-brand-300"></div>
              <div class="h-px w-12 bg-gradient-to-r from-transparent via-brand-300 to-transparent"></div>
            </div>
          </ul>
        </div>
        <div class="flex items-center gap-2 text-xs text-brand-600">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          <span>Our advanced brand ranking system guarantees you the best brands to work with. You can also filter brands by category, country, and more.</span>
        </div>
      </div>`,
      side: "right" as const,
      align: "start" as const,
    },
  },
];

const startBrandAndProgramsTour = (
  tourDriver: Driver,
  onNextClick: DriverHook,
  onPrevClick: DriverHook,
  isMarketplaceHidden = false
) => {
  tourDriver.setConfig(defaultTourConfig);
  // Here we set the unique steps for the FIRST tour
  tourDriver.setSteps(
    filterMarketplaceSteps(
      brandsAndProgramsTourSteps,
      isMarketplaceHidden
    ).map((step) => ({
      ...step,
      popover: {
        ...step.popover,
        onNextClick: (element, step, config) => {
          onNextClick(element, step, config);
          setTimeout(() => {
            tourDriver.moveNext();
          }, 200);
        },
        onPrevClick: (element, step, config) => {
          onPrevClick(element, step, config);
          setTimeout(() => {
            tourDriver.movePrevious();
          }, 200);
        },
      },
    }))
  );
  tourDriver.drive();
};

export default startBrandAndProgramsTour;
